import React from 'react'

export default function UiDotLoader(props) {
    

    return (
        <>
        <div className="center-body">
            <div className="loader-ball-14">
                <div className="d_circle1"></div>
                <div className="d_circle2"></div>
                <div className="d_circle3"></div>
                <div className="d_circle4"></div>
                <div className="d_circle5"></div>
                <div className="d_circle6"></div>
                <div className="d_circle7"></div>
                <div className="d_circle8"></div>
                <div className="d_circle9"></div>
                <div className="d_circle10"></div>
                <div className="d_circle11"></div>
                <div className="d_circle12"></div>
            </div>
        </div>
            
        </>
    )
}
